var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',{attrs:{"nopadding":"","two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-sub-title',[_vm._v("Ledger")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm.data.accountLedgerName))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60f3074","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/masters/forms/expense_categories/display_tabs/details.vue
// module id = null
// module chunks = 